var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isMobile
    ? _c("div", { staticClass: "testimonials-wrapper wrapper-desktop" }, [
        _vm.testimonials.length > 1
          ? _c("div", { staticClass: "container-fluid position-absolute" }, [
              _c("div", { staticClass: "row testimonial-row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-8 position-relative" },
                  [
                    _c("div", { staticClass: "slider-wrapper h-100" }, [
                      _c(
                        "div",
                        { staticClass: "testimonials-slider" },
                        _vm._l(_vm.testimonials, function(testimonial, index) {
                          return _c("div", { key: testimonial.id }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "testimonial-slider-image testimonial-image",
                                attrs: { "data-index": index }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "image-wrapper d-flex" },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid w-100",
                                      attrs: {
                                        src:
                                          testimonial.acf.images[0].sizes
                                            .medium_large,
                                        alt: testimonial.post_title
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "container" }, [
          _vm.testimonials.length == 1 && _vm.activeTestimonial != null
            ? _c("div", { staticClass: "row large-gutters" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h3", { staticClass: "mb-40" }, [
                    _vm._v(_vm._s(_vm.title))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg-6 mb-32 mb-lg-0" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex w-100 h-100 testimonial-image" },
                    [
                      _c("img", {
                        staticClass: "img-fluid w-100",
                        attrs: {
                          src:
                            _vm.activeTestimonial.acf.images[0].sizes
                              .medium_large,
                          alt: _vm.activeTestimonial.post_title
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-lg-6 d-flex flex-column justify-content-center py-lg-40"
                  },
                  [
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.activeTestimonial != null
                        ? _c(
                            "div",
                            {
                              key: _vm.activeTestimonial.id,
                              staticClass:
                                "w-100 d-flex align-items-start flex-column justify-content-center"
                            },
                            [
                              _vm.activeTestimonial.acf.company_logo
                                ? _c("img", {
                                    staticClass: "mb-24",
                                    attrs: {
                                      src:
                                        _vm.activeTestimonial.acf.company_logo
                                          .url,
                                      alt: _vm.activeTestimonial.post_title
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("blockquote", { staticClass: "mb-16" }, [
                                _vm._v(_vm._s(_vm.activeTestimonial.acf.quote))
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "d-block author font-weight-light",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.activeTestimonial.post_title
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.activeTestimonial.acf.story != null &&
                              _vm.activeTestimonial.acf.story.length > 0
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-accent mt-40",
                                      attrs: {
                                        href: _vm.route("nl.story", {
                                          slug:
                                            _vm.activeTestimonial.acf.story[0]
                                              .post_name
                                        })
                                      }
                                    },
                                    [_vm._v("Lees het verhaal")]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.testimonials.length > 1
            ? _c("div", { staticClass: "row testimonial-row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-8 position-relative" },
                  [
                    _c("h3", { staticClass: "position-absolute" }, [
                      _vm._v(_vm._s(_vm.title))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-4 overlaying" },
                  [
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.activeTestimonial != null
                        ? _c(
                            "div",
                            {
                              key: _vm.activeTestimonial.id,
                              staticClass:
                                "testimonial-content w-100 d-flex align-items-start flex-column justify-content-center"
                            },
                            [
                              _vm.activeTestimonial.acf.company_logo
                                ? _c("img", {
                                    staticClass: "mb-24",
                                    attrs: {
                                      src:
                                        _vm.activeTestimonial.acf.company_logo
                                          .url,
                                      alt: _vm.activeTestimonial.post_title
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("blockquote", { staticClass: "mb-16" }, [
                                _vm._v(_vm._s(_vm.activeTestimonial.acf.quote))
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "d-block author font-weight-light",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.activeTestimonial.post_title
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.activeTestimonial.acf.story != null &&
                              _vm.activeTestimonial.acf.story.length > 0
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-accent mt-40",
                                      attrs: {
                                        href: _vm.route("nl.story", {
                                          slug:
                                            _vm.activeTestimonial.acf.story[0]
                                              .post_name
                                        })
                                      }
                                    },
                                    [_vm._v("Lees het verhaal")]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "custom-controls" }, [
                      _c("span", {
                        staticClass: "prev",
                        on: { click: _vm.previousSlide }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "next",
                        on: { click: _vm.nextSlide }
                      })
                    ])
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      ])
    : _c("div", { staticClass: "wrapper-mobile" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h3", { staticClass: "mb-40" }, [_vm._v(_vm._s(_vm.title))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "testimonials-slider" },
          _vm._l(_vm.testimonials, function(testimonial) {
            return _c("div", { key: testimonial.id }, [
              _c("img", {
                staticClass: "img-fluid w-100 mb-40",
                attrs: {
                  src: testimonial.acf.images[0].sizes.medium_large,
                  alt: testimonial.post_title
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column justify-content-center py-lg-40"
                },
                [
                  _c("transition", { attrs: { name: "fade" } }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-100 px-24 d-flex align-items-start flex-column justify-content-center"
                      },
                      [
                        testimonial.acf.company_logo
                          ? _c("img", {
                              staticClass: "mb-24",
                              attrs: {
                                src: testimonial.acf.company_logo.url,
                                alt: testimonial.post_title
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("blockquote", { staticClass: "mb-16" }, [
                          _vm._v(_vm._s(testimonial.acf.quote))
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "d-block author font-weight-light",
                          domProps: {
                            innerHTML: _vm._s(testimonial.post_title)
                          }
                        }),
                        _vm._v(" "),
                        testimonial.acf.related_story != null &&
                        testimonial.acf.related_story.length > 1
                          ? _c(
                              "a",
                              {
                                staticClass: "btn btn-accent mt-40",
                                attrs: {
                                  href: _vm.route("nl.story", {
                                    slug: testimonial.acf.related_story[0].slug
                                  })
                                }
                              },
                              [_vm._v("Lees het verhaal")]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ],
                1
              )
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "custom-controls mt-24" }, [
          _c("span", { staticClass: "prev", on: { click: _vm.previousSlide } }),
          _vm._v(" "),
          _c("span", { staticClass: "next", on: { click: _vm.nextSlide } })
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }